"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const ChatbotWidget = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Only inject script on homepage
    if (pathname === "/") {
      const script = document.createElement("script");
      script.id = process.env.NEXT_PUBLIC_MESSENGER_WIDGET_ID || "";
      script.src = process.env.NEXT_PUBLIC_MESSENGER_WIDGET_SRC || "";
      script.defer = true;
      script.textContent =
        process.env.NEXT_PUBLIC_MESSENGER_WIDGET_CONTENT || "";

      document.head.appendChild(script);
    }

    return () => {
      // Clean up botpenguin root elements
      const botpenguinRoot = document.getElementsByTagName("botpenguin-root");
      if (botpenguinRoot.length > 0) {
        botpenguinRoot[0].remove();
      }

      // Clean up the script element
      const scriptElement = document.getElementById(
        process.env.NEXT_PUBLIC_MESSENGER_WIDGET_ID || "",
      );
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [pathname]);

  return null;
};

export default ChatbotWidget;
